import * as actions from "./actions";
import * as getters from "./getters";
import * as mutations from "./mutations";
import { SurchargeState } from "./types";

const state: SurchargeState = {
  rate: 0,
  label: "",
  effective_date: null,
  fetchedAt: 0
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};
